<template>
    <div class="min-w-100">
        {{ options }}
    </div>
</template>

<script>
export default {
    name: "check-cell",
    props: {
        cell: {
            type: Object,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
    },
    computed: {
        options() {
            let options = [];

            this.cell.checkedOptions.forEach((o) => {
                let option = this.column.options.find(
                    (opt) => opt.id === o.optionId
                );
                options.push(option.text);
            });

            return options.length > 0 ? options.join(", ") : "-";
        },
    },
};
</script>